export default "__VITE_ASSET__BChbNZQP__"